// Ayudantes para escribir ejemplos: colocar piezas en agujeros de la protoboard y tender cables.
import { getPins, getDef, resolveProps } from '../parts/index.js';
import { toWorld, rotXZ } from '../connectivity.js';

/** Posición para que el primer pin insertable (o el pin indicado) de la pieza caiga en el agujero. */
export function at(bb, hole, type, { rot = 0, pin = null, props = {} } = {}) {
  const bbPins = getPins(bb.type, resolveProps(bb.type, bb.props));
  const h = bbPins.find((p) => p.name === hole);
  if (!h) throw new Error(`Agujero inexistente: ${hole}`);
  const [hx, hz] = toWorld(bb, h.x, h.z);
  const pins = getPins(type, resolveProps(type, props));
  const p = pin ? pins.find((x) => x.name === pin) : pins.find((x) => x.insert) || pins[0];
  const [px, pz] = rotXZ(p.x, p.z, rot);
  return { x: round(hx - px), z: round(hz - pz), rot };
}

function round(v) {
  return Math.round(v * 1000) / 1000;
}

/** Arma una pieza. */
export function part(id, type, props = {}, pos = { x: 0, z: 0, rot: 0 }) {
  getDef(type);
  return { id, type, x: pos.x, z: pos.z, rot: pos.rot || 0, props };
}

/** Cables a partir de pares 'pieza:pin'. */
export function wires(list) {
  return list.map(([a, b, color], i) => {
    const [pa, ...ra] = a.split(':');
    const [pb, ...rb] = b.split(':');
    return { id: 'w' + (i + 1), a: { part: pa, pin: ra.join(':') }, b: { part: pb, pin: rb.join(':') }, color: color || 'green' };
  });
}

export const UNO = { id: 'uno', type: 'arduino-uno', x: 0, z: 0, rot: 0, props: {} };
